export default {"src":"/_next/static/media/x.4121ac09.svg","height":20,"width":20};